import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentServicingModule } from 'app/partials/content-servicing/content-servicing.module';
import { MainNavbarModule } from 'app/partials/main-navbar/main-navbar.module';
import { FooterModule } from '../partials/footer/footer.module';
import { ServicingRoutingModule } from './servicing-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ServicingRoutingModule, FooterModule, MainNavbarModule, ContentServicingModule],
  exports: []
})
export class ServicingModule {}
